import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper, Alert } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            p: { xs: 4, sm: 6 },
            textAlign: 'center',
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
              animation: 'shake 2s ease-in-out infinite',
              '@keyframes shake': {
                '0%, 100%': { transform: 'rotateZ(0deg)' },
                '10%, 30%, 50%, 70%, 90%': { transform: 'rotateZ(-3deg)' },
                '20%, 40%, 60%, 80%': { transform: 'rotateZ(3deg)' },
              },
            }}
          >
            <LockIcon sx={{ fontSize: 100, color: '#fb8c00' }} />
          </Box>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '3rem', sm: '4rem' },
              fontWeight: 'bold',
              background: 'linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 1,
            }}
          >
            403
          </Typography>

          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            Zugriff verweigert
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#666',
              mb: 3,
              lineHeight: 1.8,
            }}
          >
            Sie haben keine Berechtigung, diese Seite zu öffnen.
            <br />
            Kontaktieren Sie den Administrator, falls Sie der Meinung sind, dass dies ein Fehler ist.
          </Typography>

          <Alert
            icon={<SupportAgentIcon />}
            severity="warning"
            sx={{ mb: 3, justifyContent: 'flex-start' }}
          >
            <Typography variant="body2">
              Bei Fragen zu Ihren Berechtigungen wenden Sie sich bitte an den Support.
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                background: 'linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)',
                textTransform: 'none',
                fontSize: '1rem',
              }}
            >
              Zur Startseite
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                borderColor: '#fb8c00',
                color: '#fb8c00',
                textTransform: 'none',
                fontSize: '1rem',
                '&:hover': {
                  borderColor: '#ffa726',
                  backgroundColor: 'rgba(251, 140, 0, 0.1)',
                },
              }}
            >
              Zurück
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AccessDeniedPage;
